import React, { ChangeEvent, FC, useState } from 'react';

import Button from 'carbon-react/lib/components/button';
import Form from 'carbon-react/lib/components/form';
import RadioButton, { RadioButtonGroup } from 'carbon-react/lib/components/radio-button';

import { FormattedMessage, useIntl } from '@futrli/localisation';

import { ReportingSidebar } from '../reporting-sidebar/reporting-sidebar';

interface Props {
  onConfirm: (v: 'organisation' | 'workspace') => void;
  isConsolidation?: boolean;
  isModalOpen: boolean;
}

export const SelectImageLevelModal: FC<Props> = ({ onConfirm, isConsolidation, isModalOpen }) => {
  const intl = useIntl();
  const [level, setLevel] = useState<'organisation' | 'workspace'>('organisation');
  const type = isConsolidation
    ? intl.formatMessage({ id: 'reporting.consolidation', defaultMessage: 'consolidation' })
    : intl.formatMessage({ id: 'reporting.organisation', defaultMessage: 'organisation' });

  const handleLevelChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setLevel(value as 'workspace' | 'organisation');
  };

  return (
    <ReportingSidebar
      aria-label={intl.formatMessage({
        id: 'reporting.select_image_level',
        defaultMessage: 'Select image access level'
      })}
      title={intl.formatMessage({ id: 'reporting.select_image_level', defaultMessage: 'Select image access level' })}
      open={isModalOpen}
    >
      <Form
        stickyFooter
        saveButton={
          <Button buttonType="primary" size="small" onClick={() => onConfirm(level)}>
            <FormattedMessage id="common.confirm" defaultMessage="Confirm" />
          </Button>
        }
        onSubmit={() => onConfirm(level)}
      >
        <FormattedMessage
          id="reporting.upload_image_intro_organisations_and_consolidations"
          defaultMessage="You can choose to make your uploaded image available only in this {type}, or share it with all
        organisations and consolidations in your workspace."
          values={{ type }}
        />
        <RadioButtonGroup name="locking-options-group" onChange={handleLevelChange} value={level} mt={3}>
          <RadioButton
            id="image_level_organisation"
            checked={level === 'organisation'}
            name="image_level"
            value="organisation"
            label={
              <FormattedMessage
                id="reporting.only_this_organisation"
                defaultMessage="Only in this {type}"
                values={{ type }}
              />
            }
          />
          <RadioButton
            id="image_level_workspace"
            checked={level === 'workspace'}
            name="image_level"
            value="workspace"
            label={
              <FormattedMessage
                id="reporting.all_organisations_and_consolidations_in_your_workspace"
                defaultMessage="All organisations and consolidations in your workspace"
              />
            }
          />
        </RadioButtonGroup>
      </Form>
    </ReportingSidebar>
  );
};
